module.exports = __webpack_public_path__ + "img/payu-logo.da501d67.png";